import { TranslateResult } from 'vue-i18n'
import { useI18n as _useI18n } from 'vue-i18n'

export const useI18n = (): {
  t: (path: string, fallbackStr: string) => TranslateResult
  getLocalisedMessageWithFallback: (
    path: string,
    fallbackPath: string,
    fallbackStr: string
  ) => TranslateResult
} => {
  const { t, te } = _useI18n()

  /**
   * Extend useI18n.t with a fallback string.
   * @param {string} path the path of the message
   * @param {string} fallbackStr the fallback string
   * @returns {string} message
   */
  const messageWithFallback = (
    path: string,
    fallbackStr: string
  ): TranslateResult => {
    if (!t) return fallbackStr
    return te(path) ? t(path) : fallbackStr
  }

  /**
   * Returns a localised message
   * If the path does not exist, it will return the message on the fallback path
   * @param {string} path the path of the localised message
   * @param {string} fallbackPath the path to the fallback translation
   * @param {string} fallbackStr the fallback string
   * @returns {string} localised message
   */
  const getLocalisedMessageWithFallback = (
    path: string,
    fallbackPath: string,
    fallbackStr: string
  ): TranslateResult => {
    if (!t) return fallbackStr
    return te(path) ? t(path) : messageWithFallback(fallbackPath, fallbackStr)
  }

  return {
    ..._useI18n(),
    t: messageWithFallback,
    getLocalisedMessageWithFallback,
  }
}

export default useI18n
